// extracted by mini-css-extract-plugin
export var printerCard = "_ap-1";
export var printerCardConfigured = "_ap-2";
export var printerCardError = "_ap-3";
export var printerCardsContainer = "_ap-0";
export var printerIcon = "_ap-8";
export var printerIconConfigured = "_ap-5";
export var printerIconContainer = "_ap-4";
export var printerIconError = "_ap-6";
export var printerIconUnconfigured = "_ap-7";
export var workstationsTableCard = "_ap-9";